module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contain"
  }, [_c('el-dialog', {
    attrs: {
      "title": "赛区选择",
      "visible": _vm.isShow
    },
    on: {
      "update:visible": function($event) {
        _vm.isShow = $event
      },
      "close": _vm.onClose
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输关键字搜索"
    },
    on: {
      "input": _vm.onSearch
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_vm._v("可选列表")]), _vm._v(" "), (_vm.options.length > 0) ? _c('div', {
    staticClass: "picker-cell-group"
  }, _vm._l((_vm.options), function(item, index) {
    return _c('div', {
      staticClass: "picker-cell",
      attrs: {
        "v-if": index < _vm.limit
      }
    }, [_c('el-checkbox', {
      attrs: {
        "value": item.checked
      },
      on: {
        "change": function($event) {
          return _vm.toggle(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 0) : _c('div', [_vm._v("\n      没有记录...\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f59b7a9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/picker/SaiquPicker.vue
// module id = 1421
// module chunks = 0